export type AppStateResidentsStatus = {
    bedStatuses: ResidentStatusMap;
    activityStatuses: ResidentStatusMap;
    locationStatuses: ResidentStatusMap;
    // postureStatuses: ResidentStatusMap;
    isLoading: boolean;
};

export type ResidentStatusMap = {
    [key: string]: ResidentStatus;
};

export type ResidentStatus = ResidentBedStatus | ResidentActiveStatus | ResidentLocationStatus;
export type ResidentBedStatus = {
    id: ResidentStatusNames;
    value: BedStatusValue;
    dateTime: string;
    isMoving: boolean;
};

export type ResidentLocationStatus = {
    id: ResidentStatusNames;
    bed: string;
    dateTime: string;
    deviceId: string;
    previous: string;
    previousDatetime: string;
    roomNumber: string;
};

// export type ResidentPostureStatus = {
//     id: ResidentStatusNames;
//     value: PostureStatusValue;
//     dateTime: string;
//     previousDatetime: string;
// };

// export enum PostureStatusValue {
//     UNKNOWN = 'unknown',
//     LEFT = 'left',
//     RIGHT = 'right',
//     STOMACH = 'stomach',
//     STAND = 'stand',
//     BACK = 'back',
//     FALL = 'fall',
// }

export type ResidentActiveStatus = {
    id: ResidentStatusNames;
    value: boolean;
};

export enum ResidentStatusNames {
    BED = 'bed',
    ACTIVE = 'activity',
    LOCATION = 'location',
    POSTURE = 'posture',
}

export enum BedStatusValue {
    IN_BED = 'inBed',
    OUT_OF_BED = 'outOfBed',
    INIT = 'init',
}

export type BedStatusSocket = {
    status: BedStatusValue;
    residentId: string;
};

export type ActivityStatusSocket = {
    value: boolean;
    residentId: string;
};

export type ResidentStatusesSocket = {
    bedStatus: BedStatusSocket;
    activityStatus: ActivityStatusSocket;
};

export const EMPTY_BED_STATUS: ResidentBedStatus = {
    dateTime: '',
    id: ResidentStatusNames.BED,
    isMoving: false,
    value: BedStatusValue.INIT,
};

export const EMPTY_ACTIVITY_STATUS: ResidentActiveStatus = {
    id: ResidentStatusNames.ACTIVE,
    value: false,
};

export const EMPTY_LOCATION_STATUS: ResidentLocationStatus = {
    id: ResidentStatusNames.LOCATION,
    bed: null,
    dateTime: '',
    deviceId: null,
    previous: null,
    previousDatetime: '',
    roomNumber: null,
};
